import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { GameShareLink } from "@nestcoinco/hyper-api-gateway-api-client";

import { STORED_ATOM_KEYS } from "../constants";
import {
  GameFlowState,
  GameType,
  GamePlayEvents,
} from "../../../utils/constants";

const activeGameIdSessionStorageJson = createJSONStorage<string | null>(
  () => sessionStorage
);
export const activeGameIdAtomWithStorage = atomWithStorage<string | null>(
  STORED_ATOM_KEYS.ACTIVE_GAME_ID,
  null,
  activeGameIdSessionStorageJson,
  { getOnInit: true } //pull initial data from storage
);
activeGameIdAtomWithStorage.debugLabel = "active-game-id-stored";

const gameFlowStateSessionStorageJson = createJSONStorage<GameFlowState | null>(
  () => sessionStorage
);
export const gameFlowStateAtomWithStorage =
  atomWithStorage<GameFlowState | null>(
    STORED_ATOM_KEYS.GAME_FLOW_STATE,
    null,
    gameFlowStateSessionStorageJson,
    { getOnInit: true }
  );
gameFlowStateAtomWithStorage.debugLabel = "game-flow-state-stored";

const gameTypeSessionStorageJson = createJSONStorage<GameType | null>(
  () => sessionStorage
);
export const gameTypeAtom = atomWithStorage<GameType | null>(
  STORED_ATOM_KEYS.GAME_TYPE,
  null,
  gameTypeSessionStorageJson,
  { getOnInit: true }
);
gameTypeAtom.debugLabel = "game-type-stored";

export const didUserClickToInitiateGameAtom = atom(false);
didUserClickToInitiateGameAtom.debugLabel = "did-user-click-to-initiate-game";

export const DEFAULT_VISIBLE_GAME_INDEX = 0;
export const visibleGameIndexAtom = atom(DEFAULT_VISIBLE_GAME_INDEX);
visibleGameIndexAtom.debugLabel = "visible-game-index";

export enum GamesFilterOptions {
  POPULAR,
  FAVORITES,
  FREE,
}
export const gamesFilterIdAtom = atom(GamesFilterOptions.POPULAR);
gamesFilterIdAtom.debugLabel = "games-filter-id";

export const gameShareLinksAtomWithStorage = atomWithStorage<Record<
  string,
  GameShareLink
> | null>(STORED_ATOM_KEYS.GAME_SHARE_LINKS, null);
gameShareLinksAtomWithStorage.debugLabel = "game-share-links-stored";

export const gameDetailsDrawerSlugAtom = atom<string | undefined>(undefined);
gameDetailsDrawerSlugAtom.debugLabel = "game-details-drawer-slug";

export const paywallDrawerOpenAtom = atom(false);
paywallDrawerOpenAtom.debugLabel = "paywall-drawer-open";

type ScreenOrientationType = "landscape" | "portrait";
type PlatformType = "mobile" | "desktop";

export const gamePlayEventNameAtom = atom<GamePlayEvents>();
export const gamePlayEventDataAtom = atom<
  | {
      name?: string;
      data?: {
        recommendedOrientation?: ScreenOrientationType;
        currentOrientation?: ScreenOrientationType;
        recommendedPlatform?: PlatformType;
      };
    }
  | undefined
>();
